import get from "lodash/get";
import ReactApexChart from "react-apexcharts";

// @ts-expect-error legacy code
import Formatter from "@/legacy/Formatter.js";
import {shortDateTimeUser} from "@/lib/format.tsx";
import {PSMetric} from "@/lib/queries/pagespeed.ts";
import {AccountUser} from "@/lib/types/accounts.ts";

interface LineChartProps {
  series: unknown[];
  labels: PSMetric[];
  user: AccountUser;
}

export const LineChart = ({series, labels, user}: LineChartProps) => {
  const colors = ["#00aa66", "#66a1df", "#0074ce", "#FF6384", "#36A2EB", "#FFCE56"];
  const chartData = Object.keys(series).map((name, index) => {
    return {
      name: labels ? labels[index].label : name,
      data: (get(series, name, []) || []).map((data) => ({x: new Date(data[0]), y: data[1]})),
      color: colors[index],
    };
  });
  const options = {
    chart: {
      animations: {
        enabled: false,
      },
      height: 350,
      type: "line",
      zoom: {
        enabled: false,
      },
      redrawOnParentResize: true,
    },
    stroke: {
      curve: "smooth",
    },
    grid: {
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
      xaxis: {
        lines: {
          show: true,
        },
      },
    },
    xaxis: {
      type: "datetime",
    },
    yaxis: {
      labels: {
        // @ts-expect-error legacy code
        formatter: function (value) {
          const metric = labels[0];
          let tickValue = value;

          if (metric.datatype === "FLOAT") {
            tickValue = value.toFixed(2);
          }

          if (metric.unit === "MILLISECOND") {
            tickValue = value.toFixed(0) + " ms";
          } else if (metric.unit === "BYTE") {
            tickValue = Formatter.humanBytes(value);
          } else if (metric.unit === "SCORE") {
            tickValue = (value * 100).toFixed(0) + "%";
          }
          return tickValue;
        },
      },
    },
    tooltip: {
      x: {
        // @ts-expect-error legacy code
        formatter: function (value) {
          return shortDateTimeUser(new Date(value).toISOString(), user);
        },
      },
      y: {
        // @ts-expect-error legacy code
        formatter: function (value, info) {
          const metric = labels[info.seriesIndex];
          if (!metric) {
            return value.toFixed(2);
          }
          if (metric.datatype === "FLOAT") {
            value = value.toFixed(2);
          }
          if (metric.unit === "MILLISECOND") {
            value = value + " ms";
          } else if (metric.unit === "BYTE") {
            value = Formatter.humanBytes(value);
          } else if (metric.unit === "SCORE") {
            value = (value * 100).toFixed(0) + "%";
          }
          return value;
        },
      },
    },
  };
  // @ts-expect-error legacy code
  return <ReactApexChart options={options} series={chartData} type="line" height={350} />;
};
